// extracted by mini-css-extract-plugin
export default {"userTemplate":"style_userTemplate__gWQ-A","userTemplateContent":"style_userTemplateContent__WELrs"};